export default __webpack_public_path__ + "static/media/mhc-white.855de399.svg";